import { fromJS } from 'immutable'
import {
  LEAVE_TYPE_LIST_REQUEST,
  LEAVE_TYPE_LIST_SUCCESS,
  LEAVE_TYPE_LIST_FAILURE,
  LEAVE_TYPE_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_TYPE_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_TYPE_LIST_SUCCESS:
      return state
        .set('leaveTypes', fromJS(action.payload.leaveType))
        .set('isFetching', false)
    case LEAVE_TYPE_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LEAVE_TYPE_LIST_RESET:
      return state
        .delete('leaveTypes')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-type/leave-type-list-reducer.js